import React from "react";
import { useSite } from "../context/SiteContext";
import useReveal from "../hooks/useReveal";

export default function Legacy() {
  useReveal();
  const { c } = useSite();
  const { legacy } = c;
  return (
    <section id="legacy" className="bg-ink2 py-28 sm:py-40">
      <div className="max-w-[1220px] mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <div className="flex items-center gap-4 mb-7">
            <span className="eyebrow">{legacy.label}</span>
          </div>
          <h2 className="font-display text-4xl sm:text-6xl font-light leading-[1.02] text-parchment">{legacy.title}</h2>
          <p className="mt-5 font-display italic text-2xl text-parchment/60">{legacy.intro}</p>
        </div>

        <div className="grid lg:grid-cols-3 gap-4 mt-16">
          {legacy.items.map((it, i) => (
            <figure
              key={i}
              className={`reveal img-zoom border border-[var(--c-border)] bg-ink2 ${it.span}`}
              style={{ animationDelay: `${i * 100}ms` }}
            >
              <img src={it.image} alt={it.caption} className="w-full h-72 lg:h-80 object-cover" />
              <figcaption className="px-5 py-4 border-t border-[var(--c-border)]">
                <p className="font-display italic text-lg text-parchment/85 leading-snug">{it.caption}</p>
                {it.credit && (
                  <span className="mt-2 block font-label text-[0.5rem] uppercase tracking-[0.12em] text-parchment/45">
                    {it.credit}
                  </span>
                )}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
